    (function () {
  const pendingByList = new WeakMap();
  const prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function onThumbClick(e) {
    const btn = e.target.closest('button.thumbnail');
    if (!btn) return;

    const main = btn.closest('section[id^="MainProduct-"]');
    if (!main) return;

    const item = btn.closest('.thumbnail-list__item');
    const list = item && item.closest('.thumbnail-list');
    if (!item || !list) return;

    if (list.scrollWidth <= list.clientWidth + 1) return;

    const prevRaf = pendingByList.get(list);
    if (prevRaf) cancelAnimationFrame(prevRaf);

    const rafId = requestAnimationFrame(function () {
      pendingByList.delete(list);

      const first = list.querySelector('.thumbnail-list__item');
      const second = first && first.nextElementSibling;

      if (item === first || item === second) {
        list.scrollTo({
          left: 0,
          behavior: prefersReducedMotion ? 'auto' : 'smooth',
        });
        return;
      }

      const targetLeft =
        item.offsetLeft - (list.clientWidth / 2 - item.clientWidth / 2);

      const maxLeft = Math.max(0, list.scrollWidth - list.clientWidth);

      list.scrollTo({
        left: Math.max(0, Math.min(targetLeft, maxLeft)),
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
      });
    });

    pendingByList.set(list, rafId);
  }

  document.addEventListener('click', onThumbClick);
})();